import apiFetch from '../apiFetch'

export default function (idPoolExtraccion) {
  return apiFetch({endPoint: `Pool/getPool?idPool=${idPoolExtraccion}`, method: 'GET', body: null})
}
